import React from 'react'

import { Container, ProgressBar, Percentage, ProgressContainer } from './styles'

export interface ProgressProps {
  percentage: number
  page: string
}

const Progress: React.FC<ProgressProps> = ({ percentage, page }) => {
  return (
    <Container>
      <ProgressContainer namePage={page}>
        <ProgressBar percentage={percentage} />
      </ProgressContainer>
      <Percentage>{percentage} %</Percentage>
    </Container>
  )
}

export default Progress
